<template>
	<div>
		<h2 class="font-size-xs-25 ">
			<span
				class="
					d-inline-block
					animate__animated
					animate__shakeX animate__delay-1s
				"
			> 👋</span> Hola de nuevo
		</h2>

		<h5 class="mb-4">
			Inicia sesión para empezar
		</h5>

		<div class="py-4" />

		<form
			class="mb-4"
			@submit.prevent="login"
		>
			<div class="row">
				<div class="col-12 text-left">
					<a-input
						v-model="username"
						v-focus
						size="large"
						placeholder="Usuario / Email"
						class="mb-3"
						:disabled="loading"
					>
						<a-icon
							slot="prefix"
							type="user"
						/>
					</a-input>

					<a-input
						v-model="password"
						size="large"
						placeholder="Contraseña"
						type="password"
						class="mb-4"
						:disabled="loading"
					>
						<a-icon
							slot="prefix"
							type="lock"
						/>
					</a-input>

					<a-button
						class="font-weight-bold font-size-18"
						block
						type="primary"
						html-type="submit"
						:disabled="!passes"
						:loading="loading"
						size="large"
					>
						Acceder
					</a-button>
				</div>
			</div>
		</form>

		<a
			v-if="$app.pack"
			class="d-inline-flex align-items-center float-left text-light-primary"
			@click="$emit('back')"
		>
			<a-icon
				type="arrow-left"
				class="mr-2"
			/>
			Atrás
		</a>

		<router-link
			:to="{ name: '_forgotPassword' }"
			class="float-right d-inline-flex align-items-center"
		>
			<a-icon
				type="question-circle"
				class="mr-2"
			/>
			¿Olvidaste tu contraseña?
		</router-link>
	</div>
</template>

<script>

export default {
	data() {
		return {
			username: '',
			password: '',
			loading: false
		};
	},
	computed: {
		passes() {
			if (this.username && this.password) {
				if (this.username.length > 3 && this.password.length > 3) return true;
			}

			return false;
		}
	},
	created() {
		if (this.$gestios.profile.Nick) this.username = this.$gestios.profile.Nick;
	},
	methods: {
		async login() {
			if (this.passes) {
				this.loading = true;

				const login = await this.$gestios.auth.login({
					username: this.username,
					password: this.password,
					project: this.$gestios.project.name
				});

				if (login.ok) {
					window.location.href = '/';
				} else {
					this.$toast.error(login.message);

					this.loginText = login.error;
				}

				this.loading = false;
			}
		}
	}
};
</script>

<style lang="scss" >

</style>
